import CustomBadge from './CustomBadge/Component'

const CustomBadgePlugin = {
    install(Vue) {
        Vue.component('CustomBadge', CustomBadge)
    },
}

export default CustomBadgePlugin
